export default "__VITE_ASSET__DOKRAO0g__"